<div class="gw-max-h-[min(75vh,40rem)] gw-overflow-y-auto gw-p-medium">
  <ng-container *ngIf="isProviderTransactions">
    <div
      class="gw-mb-medium gw-grid gw-grid-cols-1 gw-items-end gw-gap-medium md:gw-grid-cols-12"
    >
      <div class="md:gw-col-span-4">
        <label class="gw-form-label">{{
          'features.recipients.providerTransactions.keyForWebhook' | translate
        }}</label>
        <gatewee-select-v3
          [items]="dataKeys"
          [(ngModel)]="selectedKeyForWebhook"
          [placeholder]="
            'features.recipients.providerTransactions.keyForWebhook' | translate
          "
        ></gatewee-select-v3>
      </div>
      <div class="md:gw-col-span-5">
        <label class="gw-form-label">{{
          'features.recipients.providerTransactions.searchBy' | translate
        }}</label>
        <div class="gw-mb-2x-small gw-flex gw-flex-wrap gw-gap-small">
          <div
            *ngFor="let opt of searchTermOptions"
            class="gw-inline-flex gw-items-center gw-gap-2x-small"
          >
            <input
              type="radio"
              [id]="'searchTerm-' + opt.value"
              name="searchTerm"
              [value]="opt.value"
              [(ngModel)]="searchTerm"
              class="gw-h-4 gw-w-4 gw-cursor-pointer"
            />
            <label
              [for]="'searchTerm-' + opt.value"
              class="gw-cursor-pointer gw-text-sm gw-text-text-secondary"
            >
              {{ opt.label | translate }}
            </label>
          </div>
        </div>
        <input
          type="text"
          class="gw-input-base gw-mt-2x-small"
          [placeholder]="
            'features.recipients.providerTransactions.searchPlaceholder'
              | translate
          "
          [(ngModel)]="searchValue"
        />
      </div>
      <div class="md:gw-col-span-3">
        <div class="gw-flex gw-flex-wrap gw-gap-small">
          <gatewee-button
            type="button"
            variant="primary"
            size="s"
            [title]="
              'features.recipients.providerTransactions.searchButton'
                | translate
            "
            (clicked)="onSearchApplyClick()"
          ></gatewee-button>
          <gatewee-button
            type="button"
            variant="secondary"
            size="s"
            [title]="'common.filters.remove' | translate"
            (clicked)="onSearchClear()"
          ></gatewee-button>
        </div>
      </div>
    </div>
  </ng-container>
  <div class="gw-pb-small">
    <div class="gw-overflow-x-auto">
      <gatewee-table-v2
        [data]="data.records"
        [columns]="columns"
        [page]="page"
        [pageSize]="10"
        [total]="data.count"
        [showSettings]="true"
        [tableId]="identifier + '-table'"
        (newPage)="pageChange($any($event))"
        (outClick)="onRowAction($any($event))"
      ></gatewee-table-v2>
    </div>
  </div>
</div>
